import { useState } from "react";
import { CheckIcon } from "../../../../assets/icons";
import { SolarProduct } from "../../../../model/solar-product/solar-product";
import { usePauseSolarProductMutation } from "../../../../service/admin-service";
import styles from "./SolarProductDialog.module.scss";
import { BounceLoader } from "react-spinners";
import { toast } from "react-toastify";
import ConfirmationDialog from "../../../../common/components/dialog/ConfirmationDialog";
import CommonDialog from "../../../../common/components/dialog/CommonDialog";
import VerifyOtp from "../../../../common/components/verifyOtp/verifyOtp";

interface SolarProductDialogProps {
	toggleDialog?: () => void;
	product?: SolarProduct;
}

const SolarProductDialog: React.FC<SolarProductDialogProps> = ({ toggleDialog, product }) => {
	const [toggleProductStatus, { data, isLoading }] = usePauseSolarProductMutation();
	const [showOtp, setShowOtp] = useState(false);
	const [showConfirmDialog, setShowConfirmDialog] = useState(false);

	const handleTogglePause = (id?: string, action?: null | string) => {
		toggleProductStatus({ id, actionCode: action })
			.unwrap()
			.then(res => {
				if (!action) {
					setShowOtp(true);
					setShowConfirmDialog(false);
				}
				if (action) {
					console.log("success");
					setShowOtp(false);
					toast.success(`Product ${product?.isDeactivated ? "unpause" : "pause"} successful`);
				}
			})
			.catch(err => toast.error(err?.data?.title as string));
	};

	const handleVerifyButton = (otp: string) => {
		handleTogglePause(product?.id, otp);
	};
	return (
		<>
			{showConfirmDialog && (
				<ConfirmationDialog
					title={`Are you sure you want to ${product?.isDeactivated ? "unpause" : "pause"} this product?`}
					description={`this action will make it ${product?.isDeactivated ? "available" : "unavailable"} for purchase by customer`}
					onCloseDialog={() => setShowConfirmDialog(false)}
					actionLoading={isLoading}
					btnText="Proceed"
					onConfirm={() => {
						handleTogglePause(product?.id, null);
					}}
				/>
			)}
			{showOtp && (
				<CommonDialog>
					<VerifyOtp actionLaoding={isLoading} handleResendOtp={() => handleTogglePause(product?.id, null)} handleVerifyButton={handleVerifyButton} onCloseDialog={() => setShowOtp(false)} />
				</CommonDialog>
			)}
			{!(showConfirmDialog || showOtp) && (
				<>
					<div className={styles.dialogBackdrop} onClick={toggleDialog} />
					<div className={styles.dialogContainer}>
						<button
							disabled={product?.isDeactivated || isLoading}
							onClick={() => {
								setShowConfirmDialog(true);
							}}
							className={`standardButton ${styles.button}`}
						>
							Pause Product
							{isLoading && !product?.isDeactivated ? <BounceLoader size={15} /> : product?.isDeactivated ? <CheckIcon /> : ""}
						</button>
						<button disabled={!product?.isDeactivated || isLoading} onClick={() => setShowConfirmDialog(true)} className={`standardButton ${styles.button}`}>
							Resume Product
							{isLoading && product?.isDeactivated ? <BounceLoader size={15} /> : !product?.isDeactivated ? <CheckIcon /> : ""}
						</button>
					</div>
				</>
			)}
		</>
	);
};
export default SolarProductDialog;
